const Springuplogo = require('../assets/images/logo.png');
const logo = require('../assets/images/springuplabslogo.png');
const globe = require('../assets/images/globle.png');
const globeicon = require('../assets/images/globeicon.png');
const contactHeroImg = require('../assets/images/contact-heroimage.png');
const Favicon = require('../assets/images/logoIcon.png');
const HdLogo = require('../assets/images/springuplabslogo.png');
const ContactHeroImg = require('../assets/images/contact_HeroImg.png');
const SantoshSir = require('../assets/images/Santosh_Sir.png');
const AnkushSir = require('../assets/images/Ankush.png');
const AsiSir = require('../assets/images/asi_sir_pic.png');
const DevendraSir = require('../assets/images/devendra_p.png');
const john = require('../assets/images/john123.png');
const MarkusDoetsch = require('../assets/images/MarkusDoetsch.png');
const MohanSir = require('../assets/images/MohanSir.png');
const ThomasLang = require('../assets/images/THOMASLANG.png');
const ArnfinnBlom = require('../assets/images/Arnfinn.png');
const Tushar = require('../assets/images/Tushar.png');
const Abhilash_Sir = require('../assets/images/Abhilash_Sir.png');
const MD = require('../assets/images/MD.png');
const tomV = require('../assets/images/tomV.png');
const ronny = require('../assets/images/ronny.png');
const MujbourR = require('../assets/images/MujbourR.png');
const deniserai = require('../assets/images/deniserai.png');
const dwight = require('../assets/images/dwight.png');
const frankie = require('../assets/images/frankie.png');
const ronnynilesen = require('../assets/images/ronnynilesen.png');
const StephenThomas = require('../assets/images/StephenThomas.png');
const arvinpic = require('../assets/images/arvinpic.png');
const wisr = require('../assets/images/wisr.png');
const hkm = require('../assets/images/hkm.png');
const hayysoft = require('../assets/images/hayysoft.png');
const leadX = require('../assets/images/leadX.png');
const LGB = require('../assets/images/LBG.png');
const improve = require('../assets/images/improve.png');
const sprotly = require('../assets/images/sprotly.png');
const dataScal = require('../assets/images/dataScal.png');
const LTIN1 = require('../assets/images/LTIN.png');
const Aviat = require('../assets/images/Aviat.png');
const TomorrowThings = require('../assets/images/TomorrowThings.png');
const BeyondBeauty = require('../assets/images/BeyondBeauty.png');
const HelathMotivate = require('../assets/images/HelathMotivate.png');
const Ashok_Kumar = require('../assets/images/Ashok_Kumar2.png');
const YaniSanaka = require('../assets/images/YaniSanaka.png');
const trupti = require('../assets/images/trupti.png');
const Smita = require('../assets/images/Smita.png');
const HKM1 = require('../assets/images/HKM1.png');
const hayySoft_System = require('../assets/images/hayySoft_SyStem.png'); 
const  Arribatec = require('../assets/images/Arribatec.png');
const DataScal = require('../assets/images/DataScal1.png');
const RPA = require('../assets/images/RPA.png');
const SmartParley = require('../assets/images/SmartParley.png');
const Wisr1 = require('../assets/images/Wisr1.png');
const RightHub = require('../assets/images/RightHub.png');
const Netwrkai = require('../assets/images/Netwrkai.png');
const Marksmen = require('../assets/images/Marksmen.png');
const WkUp = require('../assets/images/WkUp.png');
const Accurants = require('../assets/images/Accurants.png');
const Deep = require('../assets/images/Deep.png');
const Sproutly = require('../assets/images/Sproutly.png');
const LittlegayBook = require('../assets/images/LittlegayBook.png');
const Leadx1  = require('../assets/images/Leadx1.png');
const YieldSec = require('../assets/images/YieldSec.png');
const Skyler = require('../assets/images/Skyler.png');
const AppSavi = require('../assets/images/AppSavi.png');
const NeuroFlash = require('../assets/images/NeuroFlash.png'); 
// blogs banner images//
const LTIN = require('../assets/images/LTINimage.png');
const ChannaiOffice = require('../assets/images/channaioffice.jfif');
const NordicPartners = require('../assets/images/nordicPartners.png');
const SpringUpImprove = require('../assets/images/SpringupImprove.png');
const AiAgentic = require('../assets/images/AIAgentic.png');
const Serverless = require('../assets/images/serverless.png');
const Kalamkaarblog = require('../assets/images/Kalamkaarblog.png');
const DevOps_Revolution = require('../assets/images/DevOps_Revolution.png');
const CustomerBlog = require('../assets/images/CustomerBlog.jpg');
const SpringupAiNew = require('../assets/images/SpriupupAiNew.png');
const Sproutlyblog = require('../assets/images/Sproutlyblog.jpg');
const WebDesignblog = require('../assets/images/WebDesignblog.png');  
const Aviatblogimg = require('../assets/images/Aviatblogimg.png');
const ravi = require('../assets/images/ravi.jpg');
const nileshmane = require('../assets/images/nileshmane.jpg');
const AkshayThakre = require('../assets/images/akshaythakre.jpg');
const ChandradeepBhoite = require('../assets/images/ChandradeepBhoite.png');
export { Springuplogo, logo, globe, globeicon, contactHeroImg, Favicon, HdLogo, ContactHeroImg, SantoshSir,
    AnkushSir, AsiSir, DevendraSir, john, MarkusDoetsch, MohanSir, ThomasLang, ArnfinnBlom, Tushar, Abhilash_Sir, MD, tomV, ronny,
     MujbourR, deniserai, dwight, frankie, ronnynilesen, StephenThomas, arvinpic, wisr, hkm, hayysoft, leadX, LGB, improve, sprotly,
      dataScal, LTIN, ChannaiOffice, NordicPartners, SpringUpImprove,   HKM1, hayySoft_System, Arribatec, DataScal,  RPA, SmartParley, Wisr1, RightHub, Netwrkai, Marksmen, WkUp, 
      Accurants, Deep, Sproutly, LittlegayBook, Leadx1, YieldSec, Skyler, AppSavi, NeuroFlash, 
      SpringupAiNew, Sproutlyblog, WebDesignblog, CustomerBlog, DevOps_Revolution, Kalamkaarblog, AiAgentic, Serverless , Aviatblogimg, 
      Aviat, TomorrowThings, BeyondBeauty, LTIN1, HelathMotivate, ravi, nileshmane, AkshayThakre , ChandradeepBhoite, YaniSanaka, Ashok_Kumar, trupti, Smita};



const Celebration1 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations1.jpg');
const Celebration2 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations2.jpg');
const Celebration3 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations3.jpg');
const Celebration4 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations4.jpg');
const Celebration5 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations5.jpg');
const Celebration6 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations6.jpg');
const Celebration7 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations7.jpg');
const Celebration8 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations8.jpg');
const Celebration9 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations9.jpg');
const Celebration10 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations10.jpg');
const Celebration11 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations11.jpg');
const Celebration12 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations12.jpg');
const Celebration13 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations13.jpg');
const Celebration14 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations_me.jpg');
const Celebration15 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations15.jpg');
const Celebration17 = require('../assets/lifeatspringuplabs/Celebrations/Celebrations17.jpg');

const Client1 = require('../assets/lifeatspringuplabs/clients/clients.jpg');
const Client2 = require('../assets/lifeatspringuplabs/clients/clients2.jpg');
const Client3 = require('../assets/lifeatspringuplabs/clients/clients3.jpg');
const Client4 = require('../assets/lifeatspringuplabs/clients/clients4.jpg');
const Client5 = require('../assets/lifeatspringuplabs/clients/clients5.jpg');
const Client6 = require('../assets/lifeatspringuplabs/clients/clients6.jpg');
const Client7 = require('../assets/lifeatspringuplabs/clients/clients7.jpg');
const Client8 = require('../assets/lifeatspringuplabs/clients/clients8.jpg');
const Client9 = require('../assets/lifeatspringuplabs/clients/clients9.png');
const Client10 = require('../assets/lifeatspringuplabs/clients/clients21.jpg');

const team1 = require('../assets/lifeatspringuplabs/Celebrations/team1.jpg');
const team2 = require('../assets/lifeatspringuplabs/Celebrations/team2.jpg');
const team3 = require('../assets/lifeatspringuplabs/Celebrations/team3.jpg');
const team4 = require('../assets/lifeatspringuplabs/Celebrations/team4.jpg');

const FunActivities1 = require('../assets/lifeatspringuplabs/FunActivities/FunActivities.jpg');
const FunActivities2 = require('../assets/lifeatspringuplabs/FunActivities/FunActivities2.jpg');
const FunActivities3 = require('../assets/lifeatspringuplabs/FunActivities/FunActivities3.jpg');
const FunActivities4 = require('../assets/lifeatspringuplabs/FunActivities/FunActivities4.jpg');
const FunActivities5 = require('../assets/lifeatspringuplabs/FunActivities/FunActivities5.jpg');
const FunActivities6 = require('../assets/lifeatspringuplabs/FunActivities/FunActivities6.jpg');
const FunActivities7 = require('../assets/lifeatspringuplabs/FunActivities/FunActivities7.jpg');
const FunActivities8 = require('../assets/lifeatspringuplabs/FunActivities/FunActivities8.jpg');

const TeamOuting1 = require('../assets/lifeatspringuplabs/TeamOuting/TeamOuting1.jpg');
const TeamOuting2 = require('../assets/lifeatspringuplabs/TeamOuting/TeamOuting2.jpg');
const TeamOuting3 = require('../assets/lifeatspringuplabs/TeamOuting/TeamOuting3.jpg');
const TeamOuting4 = require('../assets/lifeatspringuplabs/TeamOuting/TeamOuting4.jpg');
const TeamOuting5 = require('../assets/lifeatspringuplabs/TeamOuting/TeamOuting5.jpg');
const TeamOuting6 = require('../assets/lifeatspringuplabs/TeamOuting/TeamOuting6.jpg');
const TeamOuting7 = require('../assets/lifeatspringuplabs/TeamOuting/TeamOuting7.jpg');
const TeamOuting8 = require('../assets/lifeatspringuplabs/TeamOuting/TeamOuting8.jpg');



export {Celebration1,Celebration2,Celebration3,Celebration4,Celebration5,Celebration6,Celebration7,Celebration8,Celebration9,
    Celebration10,Celebration11,Celebration12,Celebration13,Celebration14 , Celebration15, Celebration17,Client1,Client2,Client3,Client4,Client5,Client6,Client7,Client8,Client9,Client10,
    FunActivities1,FunActivities2,FunActivities3,FunActivities4, FunActivities5,FunActivities6,FunActivities7,FunActivities8, team1 ,team2,team3 , team4,
    TeamOuting1,TeamOuting2,TeamOuting3,TeamOuting4,TeamOuting5,TeamOuting6,TeamOuting7,TeamOuting8};